// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/dist/cjs.js??ref--7-oneOf-1-1!../../../vue-loader/lib/loaders/stylePostLoader.js!../../../postcss-loader/src/index.js??ref--7-oneOf-1-2!../../../sass-loader/dist/cjs.js??ref--7-oneOf-1-3!../../../vue-loader/lib/index.js??vue-loader-options!./NsIcon.vue?vue&type=style&index=0&id=0464f796&lang=scss&scoped=true&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("b9180b2c", content, true, {"sourceMap":false});